export default {
  fields: {
    target: {
      type: 'selector',
      value: '',
      options: [
        {
          value: 'budget',
          min: 10000,
          max: 10000000,
        },
        {
          value: 'clicks',
          min: 300,
          max: 10000000,
        },
        {
          value: 'shows',
          min: 35000,
          max: 10000000,
        },
      ],
      sub_field: {
        name: 'desired_value',
        type: 'text',
        value: '',
      },
    },
    ad_category_id: {
      type: 'selector',
      options: [],
      value: '',
      dependencies: ['target', 'desired_value'],
      apiDependencies: [],
      apiMethod: 'fetchAdCategories',
    },
    ad_object_id: {
      type: 'selector',
      options: [],
      value: '',
      dependencies: ['target', 'desired_value', 'ad_category_id'],
      apiDependencies: ['ad_category_id'],
      apiMethod: 'fetchAdObjects',
    },
    ad_target_ids: {
      type: 'selector',
      multiple: true,
      options: [],
      value: [],
      dependencies: [
        'target',
        'desired_value',
        'ad_category_id',
        'ad_object_id',
      ],
      apiDependencies: ['ad_category_id', 'ad_object_id'],
      apiMethod: 'fetchAdTargets',
    },
  },
  target_results: {
    type: 'target_results',
    data: {},
    dependencies: [
      'target',
      'desired_value',
      'ad_object_id',
      'ad_target_ids',
      'ad_category_id',
    ],
    apiDependencies: [
      'target',
      'desired_value',
      'ad_object_id',
      'ad_target_ids',
      'ad_category_id',
    ],
    apiMethod: 'fetchTargetValueDistribution',
    tableConfig: {
      columns: {
        ad_category: {},
        ad_object: {},
        ad_target: {},
        budget: {
          accessorKey: 'budget',
          postfix: '₽',
        },
        shows: {
          accessorKey: 'shows',
        },
        clicks: {
          accessorKey: 'clicks',
        },
        cpm: {
          accessorKey: 'cpm',
          postfix: '₽',
          tooltip: true,
        },
        cpc: {
          accessorKey: 'cpc',
          postfix: '₽',
          tooltip: true,
        },
        ctr: {
          accessorKey: 'ctr',
          postfix: '%',
          tooltip: true,
        },
      },
      sorting: ['budget'],
    },
  },
}
